import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import SubNavStickers from "./SubNavStickers";
import Feature from "./Feature";
import "./category.css";

const clients = [
  {
    id: "pwdo",
    name: "Philippine Web Designers Organization",
    desc:
      "PWDO is a non-profit volunteer organization that aims to strengthen the community, champion excellence in crafting web user interfaces, and uplift the state of web design in the Philippines. We organize events to educate and sharpen the skills and professionalism of Filipino web designers and developers. In their every events they handle, they are happily giving out free stickers for their attendees, and that is where we come from, to provide them with those cool-looking stickers.",
    features: [
      {
        id: 1,
        desc:
          "PWDO is a non-profit volunteer organization that aims to strengthen the community, champion excellence in crafting web user interfaces, and uplift the state of web design in the Philippines.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1540479507/rtds_work/Stickers/PWDO2018-Logo-Mockup.jpg"
      },
      {
        id: 2,
        desc:
          "They organize events to educate and sharpen the skills and professionalism of Filipino web designers and developers. In their every events they handle, they are happily giving out free stickers for their attendees, and that is where Redtomato Design Studio come from, to provide them with those cool-looking stickers.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1540479508/rtds_work/Stickers/FFC2017-ThrowbackMockup.jpg"
      }
    ]
  },
  {
    id: "omg",
    name: "Oil My Goodness",
    desc:
      "Oil My Goodness-OMG is an all-natural skincare brand that is here for one thing: to give people a better, healthier alternative. Since 2010, They have been an advocate of the power of mother nature when it comes to beauty.",
    features: [
      {
        id: 1,
        desc:
          "Oil My Goodness-OMG is an all-natural skincare brand that is here for one thing: to give people a better, healthier alternative. Since 2010, They have been an advocate of the power of mother nature when it comes to beauty.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1543060693/rtds_work/OMG/OMG-Logo-Sticker-Mockup.jpg"
      },
      {
        id: 2,
        desc:
          "You got a product to sell, have a neat container but don't have a good label? Let's slap that sticker to any packaging that you have. Customers will line-up to buy that product!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542869006/rtds_work/OMG/Labels%20Stickers/OMG-Henna-Mockup.jpg"
      }
    ]
  }
];

class Stickers extends Component {
  render() {
    const id = this.props.match.params.id;
    const selected = clients.filter((item, i) => item.id === id);
    return (
      <div className="web-systems">
        <div className="banner-container">
          <span className="banner-text">Specialized Stickers for you!</span>
          <div className="banner">
            <img
              src="https://res.cloudinary.com/doddfudab/image/upload/v1555285054/rtds_work/workstickers/rtds_work_PWDO_FFC2017-ThrowbackMockup_new_new.png"
              alt="banner"
              className="banner"
            />
          </div>
        </div>
        <SubNavStickers />
        {selected[0] ? (
          <Feature
            data={selected[0] ? selected[0].features : []}
            desc={selected[0].desc}
          />
        ) : (
          <Feature
            data={clients[0] ? clients[0].features : []}
            name={clients[0].name}
            desc={clients[0].desc}
          />
        )}
      </div>
    );
  }
}

export default withRouter(Stickers);



// WEBPACK FOOTER //
// ./src/components/pages/category/Stickers.js